import { render } from "./MoxeyValue.vue?vue&type=template&id=552f5a24&scoped=true"
import script from "./MoxeyValue.vue?vue&type=script&lang=js"
export * from "./MoxeyValue.vue?vue&type=script&lang=js"

import "./MoxeyValue.vue?vue&type=style&index=0&id=552f5a24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552f5a24"]])

export default __exports__